module.exports = __webpack_public_path__ + "static/2-bb5aff616b2290651ee7f1c1bfc3e71e.jpg";